import * as Base64js from 'js-base64';

// 时间格式转换
export const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const Y = `${date.getFullYear()}-`;
    const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
    const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
    const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
    const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}:`;
    const s = `${date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()}`;
    return Y + M + D + h + m + s;
};

// 大小转换
export const formatSzie = (size) => {
    const sizeMB = size / 1048576;

    return `${sizeMB.toFixed(2)}MB`;
};

export const judgeMultipartUpload = (size) => {
  const sizeMB = size / 1048576;
  return sizeMB > 2;
}

// 消耗时间转换
export const formatConsumingTime = (start, end) => {
    const difTim = end - start;
    // let difTim = 1000 * 60 * 70+ 1000 *  4
    let tempTime = '';
    const hours = Math.floor(difTim / 1000 / 60 / 60);
    const minutes = Math.floor(difTim / 1000 / 60 - 60 * hours);
    const seconds = Math.floor(difTim / 1000 - 60 * 60 * hours - 60 * minutes);
    if (hours !== 0) {
        tempTime = `${hours}时${minutes < 10 ? '0' + minutes : minutes}分`;
    } else {
        if (minutes !== 0) {
            tempTime = `${minutes}分${seconds < 10 ? '0' + seconds : seconds}秒`;
        } else {
            tempTime = `${seconds}秒`;
        }
    }
    return tempTime;
};

// 时间格式转换
/*
 ** leftTime  剩余天数
 ** leftUnit  剩余的单位
 ** leftDate  到期的日期
 */
export const formatLeftTime = (expireIn) => {
    // let leftTime = 0
    // let leftUnit = '天'
    // let delta = expireIn - creatAt
    // debugger
    // let deltaTime = 3650 * 24 - delta / 60 / 60 / 100
    // if (deltaTime <= 24) {
    //     leftTime = deltaTime
    //     leftUnit = '小时'
    // } else {
    //     leftTime = parseInt(deltaTime / 24 / 10)
    //     leftUnit = '天'
    // }
    // return {
    //     leftTime, leftUnit
    // };
    let leftTime = 0;
    let leftUnit = '天';
    const date = new Date(expireIn);
    const currentTime = new Date();
    const deltaTime = (date.getTime() - currentTime.getTime()) / 60 / 60 / 100;
    if (deltaTime <= 240) {
        leftTime = deltaTime / 10;
        leftUnit = '小时';
    } else {
        leftTime = parseInt(deltaTime / 24 / 10);
        leftUnit = '天';
    }
    return {
        leftTime,
        leftUnit,
    };
};

// 数据格式校验

export const cheackFlieFormat = (fileName) => {
    // 校验 “.”的规则
};

//

export const base64UrlEncode = (str) =>
    // base64safe
    Base64js.Base64.encode(str).replace(/\//g, '_').replace(/\+/g, '-').replace(/=/g, '');

export const base64UrlDecode = (str) => {
    // base64safe
    str = str.replace(/_/g, '/').replace(/\-/g, '+');
    return Base64js.Base64.decode(str);
};

// 根据文件名或文件urn等信息解析文件类型
export const analysisFileType = (file) => {
    let temp = file.split('_');
    return temp[temp.length - 1].toLowerCase();
};

export const setStorageItem = (md5, uploadId) => {
  let config;
  const str = localStorage.getItem('obv-multi-upload');
  if (!str) {
    config = {};
  } else {
    config = JSON.parse(str);
  }

  if(uploadId){
    config[md5] = uploadId;
  } else {
    delete config[md5];
  }
  localStorage.setItem('obv-multi-upload', JSON.stringify(config));
}

export const getStorageItem = (md5) => {
  const str = localStorage.getItem('obv-multi-upload');
  if(str){
    const data = JSON.parse(str);
    if(data[md5]){
      return data[md5];
    }
  }
  return undefined;

}




// WEBPACK FOOTER //
// ./src/utils/commonUtils.js